
export abstract class ICloneable {
  /**
   * Creates a deep copy of the object.
   */
  abstract clone(): this
}
